import React from 'react';
import { LocalString, Plural, Money } from 'translate-react';
import { togglePanel } from '../actions';

let ExtrasColumns = (props, context) => {
	let { open } = props;

	return (
		<div style={{height:'100%'}}>
			<div className="accordion-col accordion-col12">
				<b>Auswahl</b>
				<ul className="checklist">
					<li><b>Tiefgaragenstellplatz</b> + 30,00 €</li>
					<li><b>ÖPNV-Ticket / 4 Tage</b> + 16,00 €</li>
				</ul>
			</div>
			<div className="accordion-col accordion-col3">
				<b><LocalString word="Summe" /></b>
				<span className="price"><Money map={{EUR: 46, CHF: 64}} /></span>
			</div>
			<div className="accordion-col accordion-col4">
				{!open ? 
				<button onClick={(e) => context.store.dispatch(togglePanel("extras"))}>
					<LocalString word="Ändern" />
				</button>
				: null}
			</div>
		</div>
	);
};
ExtrasColumns.contextTypes = { store: React.PropTypes.object };

export default ExtrasColumns;



/** WEBPACK FOOTER **
 ** ../ibe/desktop/ExtrasColumns.js
 **/